import React from 'react'
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { localized } from '@/decorators/localized'
import context from '@/context'
import { Button } from '@/components/button'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { openDialog } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { downloadFile } from '@/utils/downloader'
import { xsdSchemaTypes } from '@/enums/xsdSchemaTypes'
import { withPermissions } from '@/decorators/withPermissions'

const fileFormats = {
  excel: 0,
  xml: 1
}
@localized()
@withPermissions()
class InstitutionReportDownloadButtons extends React.Component {
    static propTypes = {
      localize: PropTypes.any,
      openDialog: PropTypes.func,
      isGranted: PropTypes.func,
      institutionReportGroup: PropTypes.any
    };

    constructor (props, context) {
      super(props, context)

      this.state = {
        downloadXlsOpen: false,
        downloadXmlOpen: false
      }
    }

    onDownloadError = () => {
      this.props.openDialog({
        dialogType: dialogTypes.alert,
        title: 'Reporting.GenerateExcel',
        content: 'Reporting.ExportDownloadError'
      })
    }

    downloadArabicCurrentDataXlsx = () => { this.downloadDataXlsx('ar') }
    downloadEnglishCurrentDataXlsx = () => { this.downloadDataXlsx('en') }
    downloadDataXlsx = (languageName) => {
      this.downloadXlsx(languageName)
    }

    downloadXlsx = (languageName) => {
      const fileAttachmentId = this.findFileAttachment(languageName, fileFormats.excel)
      if (fileAttachmentId) {
        const input = {
          reportSubmissionGroupId: this.props.institutionReportGroup.id,
          fileAttachmentId
        }

        downloadFile(input, context.api.institutionReportGroupService.downloadExport, null, null, this.onDownloadError)
      }
    }

    downloadCurrentDataXml = () => { this.downloadXml() }

    downloadXml = () => {
      const fileAttachmentId = this.findFileAttachment('en', fileFormats.xml)
      if (fileAttachmentId) {
        const input = {
          reportSubmissionGroupId: this.props.institutionReportGroup.id,
          fileAttachmentId
        }
        downloadFile(input, context.api.institutionReportGroupService.downloadExport, null, null, this.onDownloadError)
      }
    }

    downloadXsd = () => {
      downloadFile(xsdSchemaTypes.enum.InstitutionReportGroupXml, context.api.reportExportService.downloadXsdSchema, null, null, this.onDownloadError)
    }

    findFileAttachment = (languageName, exportFormat) => {
      const { exportDownloads } = this.props.institutionReportGroup
      if (exportDownloads && exportDownloads.length > 0) {
        const exportedFile = exportDownloads.find(x =>
          x.languageName === languageName &&
                x.exportFormat === exportFormat &&
                x.isAccepted === true
        )
        if (exportedFile) { return exportedFile.fileAttachmentId }
      }
      return null
    }

    render () {
      const { institutionReportGroup, localize } = this.props
      if (!institutionReportGroup) { return null }

      return (
        <div className='DownloadButtons button-section-alternative'>
          <ButtonDropdown isOpen={this.state.downloadXlsOpen} toggle={() => this.setState({ downloadXlsOpen: !this.state.downloadXlsOpen })}>
            <DropdownToggle caret>
              {localize('Reporting.DownloadXls')}
            </DropdownToggle>
            <DropdownMenu>
              <React.Fragment>
                <DropdownItem onClick={this.downloadEnglishCurrentDataXlsx}>{localize('Reporting.CurrentDataEnglish')}</DropdownItem>
                <DropdownItem onClick={this.downloadArabicCurrentDataXlsx}>{localize('Reporting.CurrentDataArab')}</DropdownItem>
              </React.Fragment>
            </DropdownMenu>
          </ButtonDropdown>
          <ButtonDropdown isOpen={this.state.downloadXmlOpen} toggle={() => this.setState({ downloadXmlOpen: !this.state.downloadXmlOpen })}>
            <DropdownToggle caret>
              {localize('Reporting.DownloadXml')}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={this.downloadCurrentDataXml}>{localize('Reporting.CurrentData')}</DropdownItem>
            </DropdownMenu>
          </ButtonDropdown>
          <Button icon='save' disabled={!this.props.isGranted(['CanViewReports', 'CanViewReportSubmissions'])} onClick={this.downloadXsd}>{localize('Reporting.DownloadXsd')}</Button>
        </div>
      )
    }
}

const mapDispatchToProps = {
  openDialog
}

export default connect(null, mapDispatchToProps)(InstitutionReportDownloadButtons)



// WEBPACK FOOTER //
// ./src/internal-app/pages/institutionReports/institutionReportDownloadButtons.js